/* todo: delete na/app/shared/forms/confirmation/confirmationModalWebu.directive.js
  & directive.legacy.js & html after all files that use the confirmation
  webu modal have been integrated; also, downgrade in index after all files that use confirmation
  webu modal have been integrated: serviceHistoryWebu, addNotesModalWebu, addServiceHistoryModalWebu,
  editServiceRecordModalWebu, addMileageWebu, and updateMileageWebu
*/
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AppConfigService,SessionStorageService} from '@ox/utils';
import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
@Component({
  // selector changed from oc-confirmation-modal-web-u for future downgrade purposes
  // components that use this modal will need to change the selector in the html file
  selector: 'webu-confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent implements OnInit {

  @Input() class: any;
  @Input() firstOption: any;
  @Input() public secondOption: any;
  @Input() public titleText: any;
  @Input() public confirmationText: any;
  @Input() public pageToTrack: any;
  @Input() public index: any;
  @Input() public firstOptionHide: any;
  @Input() public secondOptionHide: any;
  @Input() public firstOptionId: any;
  @Input() public secondOptionId: any;
  @Input() public idCallback: any;
  @Input() public id: any;
  public language: any;
  public modalId: any;
  //@Output() close = new EventEmitter();
  @Output() optionEvent = new EventEmitter();
  constructor(private ocAppConfigService: AppConfigService,
    private modalService:BsModalService,
    public modalRef: BsModalRef
    ) {
  }

  ngOnInit(): void {
    this.language = (elem: any, attr: any) => {
      this.modalId = attr.id;
      this.language = this.ocAppConfigService.bml.lang;
      if (!attr.id || attr.id === '') {
        elem.id = 'gmConfirmationModalWebU';
      }
    };
  }

  /*Callbacks that will emit to the parent
  add-notes-modal */
  public firstOptionCallback() {
    this.modalRef.hide();
    this.optionEvent.emit('first');
  }

  public secondOptionCallback() {
    this.modalRef.hide();
    this.optionEvent.emit('second');
  }


  public onClose() {
    //this.modalService._hideModal('.confirm-modal')
    //$("#" + this.id).attr("aria-expanded", false);
    this.modalRef.hide();
    this.optionEvent.emit('second');
  }
}
